import React, { useContext, useState } from "react";
import { AuthContext } from '../../../../../../auth-context'
import styled from "styled-components";
import Popover from "@material-ui/core/Popover";
import { withStyles } from "@material-ui/core/styles";

const CustomPopover = withStyles({
  paper: {
    background: "#060c29",
    borderRadius: "12px",
  },
})(Popover);

const Content = styled.div`
  color: #fff;
  padding: 6px;
  max-height: 360px;
`;

const Button = styled.button`
  background: #eaedf5;
  border: none;
  border-radius: ${props => props.theme.input.borderRadius};
  color: #333;
  cursor: pointer;
  display: block;
  font-size: 1rem;
  font-weight: 500;
  margin: 0 auto;
  width: 280px;
  padding: 8px;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 0px;
  }
`;


const Item = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  p {
    border-radius: 6px;
    color: ${props => props.isLinked ? '#666' : '#fff'};
    cursor: ${props => props.isLinked ? 'default' : 'pointer'};
    white-space: nowrap;
    padding: 6px 4px;
    margin: 4px 0px;
    width: 100%;
    transition: 0.2s ease background;
    &:hover {
      background: #ffffff2e;
    }
  }
`;

const ListItem = ({ id, name, setLinkData, setAnchorEl }) => {
  return (
    <Item 
      onClick={() => {
        setLinkData({
          id: id,
          name: name
        });
        setAnchorEl(null)
      }}
    >
      <p>{name}</p>
    </Item>
  );
};

export const TrainerButton = ({linkData, setLinkData}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { user } = useContext(AuthContext);
  const open = Boolean(anchorEl);

  return (
    <>
      <Button onClick={(e) => setAnchorEl(e.currentTarget)}>
        {linkData ?
          <p>{linkData.name}</p>
          :
          <p>Select a trainer</p>
        }
      </Button>
      <CustomPopover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl("")}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Content>
          {user.team.length !== 0 ?
            user.team.map((trainer, index) => 
              <ListItem
                key={trainer.id}
                id={trainer.id}
                name={trainer.name}
                setLinkData={setLinkData}
                setAnchorEl={setAnchorEl}
              />
            )
          :
            <p>No trainers have been added.</p>
          }
        </Content>
      </CustomPopover>
    </>
  );
};
